import initsocialfeed from "./modules/socialfeed.mjs";
import {initkarrierefilter} from "./modules/karrierefilter.mjs";
import {initsliders} from "./modules/sliders.mjs";
import {initnewsletter} from "./modules/newsletter.mjs";
import {inittimeline} from "./modules/timeline.mjs";
import {initrecipe} from "./modules/recipe.js";
//import {inithome} from "./modules/homepage.mjs";
import initautocomplete from "./modules/autocomplete.mjs";
import {initmarktberichte} from "./modules/marktberichte.js";
import initseminars from "./modules/seminars.ts";
import initmesserueckmeldung from "./modules/messerueckmeldung.mjs";
import initsmc from "./modules/socialmediacourse.mjs";
import initregistration from "./modules/registration.mjs";
import initpartner from "./modules/partner.mjs";
import initwerbung from "./modules/werbung.mjs";
import initansprechpartner from "./modules/ansprechpartner.mjs";
import initlegacyutils from "./modules/legacyutils.js";

initseminars();
if(document.querySelector(".marktberichte")){
    initmarktberichte();
}

//Rezeptergebnisse bei aktivem Filter verstecken (auf suche.htm)
if (location.href.indexOf("pa1=") !== -1) {
    $(".reciperesults").hide();
}

//Anpassung ein Tag bei CCP
$(document).ready(function () {
    toggle_closed();

    //Anpassung per JS f??ingle-main-teaser mit smt-hdl-top
    giveSmtWSmtM();

    $("a[data-toggle=tab]").on("shown.bs.tab", function () {
        $(".tab-pane").each(function () {
            $(this).find(".eqhight").responsiveEqualHeightGrid();
            $(window).trigger("scroll");
        });
    });
    $('.single-main-teaser.element').responsiveEqualHeightGrid();
    $(".teaserlist").each(function () {
        $(this).find(".single-main-teaser").responsiveEqualHeightGrid();
    });
    $('.teaser-wrapper').each(function () {
        $(this).find('.con-teaser').responsiveEqualHeightGrid();
    });
    $('.toggle.closed').on('click', function () {
        $(this).find(".single-main-teaser.element").responsiveEqualHeightGrid();
        //$('.single-main-teaser.element').responsiveEqualHeightGrid();
        $(this).find('.teaser-wrapper').each(function () {
            $(this).find('.con-teaser').responsiveEqualHeightGrid();
        });
    });


    $(".content-holder>.container-fluid>.row .col2-fi>.headline-breaker").each(function () {
        if ($(this).hasClass("text-module") && $(this).hasClass("module-intro-left")) {
            $(this).addClass("firstHeadlineOfPage");
        }
    });
    $(".eqhight").responsiveEqualHeightGrid();
    $(".smtwsht").responsiveEqualHeightGrid();
    /**Gmaps in Tabs**/
    $('a[data-toggle="tab"]').on("click", function () {
        if (typeof myMaps != 'undefined') {
            setTimeout(function () {
                if (myMaps.maps.length > 0) {
                    myMaps.maps.forEach(function (entry) {
                        google.maps.event.trigger(entry[0], "resize");
                        entry[0].setCenter(entry[1]);
                    });
                }
            }, 100);
        }
    });
}(jQuery));

//Anpassung per JS fuer single-main-teaser mit smt-hdl-top
function giveSmtWSmtM() {
    $('.single-main-teaser').each(function () {
        if ($(this).has('.smt-hdl-top').length) {
            $(this).addClass("smtwsht");
        }
    });
};

/*START Toogleboxen*/
$(".toggle").find(".module-hdl").on("click",function () {
    $(this).parent().find('.module-content').toggle();

    //GESCHLOSSEN
    if ($(this).find(".icon").hasClass('icon-bottom_arrow')) {
        $(this).find(".icon").removeClass('icon-bottom_arrow').addClass('icon-top_arrow');
        /*$(this).addClass('toggle_cl_bl_bgrnd');
        $(this).removeClass('toggle_cl_drk_bgrnd');*/
        /*START ERGAENZUNG FUER HIDDEN EUQALHIGHT UND LAZY ELEMENTE*/
        $(".con-teaser").css("height", "auto");
        setTimeout(function () {
            $(this).find('.con-teaser').responsiveEqualHeightGrid();
            $('body,html').trigger("scroll");
        }, 50);
        /*ENDE ERGAENZUNG FUER HIDDEN EUQALHIGHT UND LAZY ELEMENTE*/
    }
    //OFFEN
    else if ($(this).find(".icon").hasClass('icon-top_arrow')) {
        $(this).find(".icon").removeClass('icon-top_arrow').addClass('icon-bottom_arrow');
        /*$(this).addClass('toggle_cl_drk_bgrnd');
        $(this).removeClass('toggle_cl_bl_bgrnd');*/
    }

    if ($(this).find(".icon").hasClass('icon-bottom_arrow-std')) {
        $(this).find(".icon").removeClass('icon-bottom_arrow-std').addClass('icon-top_arrow-std');
        /*START ERGAENZUNG FUER HIDDEN EUQALHIGHT UND LAZY ELEMENTE*/
        $(".con-teaser").css("height", "auto");
        setTimeout(function () {
            $(this).find('.con-teaser').responsiveEqualHeightGrid();
            $('body,html').trigger("scroll");
        }, 50);
        /*ENDE ERGAENZUNG FUER HIDDEN EUQALHIGHT UND LAZY ELEMENTE*/
    }
    else if ($(this).find(".icon").hasClass('icon-top_arrow-std')) {
        $(this).find(".icon").removeClass('icon-top_arrow-std').addClass('icon-bottom_arrow-std');

    }
    $(this).parent('.toggle').find('.element').responsiveEqualHeightGrid();
});
/*ENDE Toogleboxen*/

//Lightbox control

function setLightboxOverflowable() {
    if ($("body.relaunch-lightbox-active").length) {
        if ($(".relaunch-lightbox-content")[0].offsetHeight === $(".relaunch-lightbox-content .scroller")[0].scrollHeight) {
            $(".relaunch-lightbox-active .scroller").css("overflow", "auto");
        }
    }
}

function setLightbox(header, content) {
    $(".relaunch-lightbox .relaunch-lightbox-header").html(header);
    $(".relaunch-lightbox .relaunch-lightbox-content .scroller").html(content);
    $("body").addClass("relaunch-lightbox-active");
    setLightboxOverflowable();
}

//Toggleboxen
function toggle_closed() {
    $(".closed").find(".module-content").toggle(false);
    $(".closed .icon").each(function () {
        if ($(this).hasClass("icon-top_arrow")) {
            $(this).removeClass('icon-top_arrow').addClass('icon-bottom_arrow');
        }
        if ($(this).hasClass("icon-top_arrow-std")) {
            $(this).removeClass('icon-top_arrow').addClass('icon-bottom_arrow-std');
        }
    });
    $(".closed").find(".module-hdl").addClass('toggle_cl_drk_bgrnd');
    $(".closed").find(".module-hdl").removeClass('toggle_cl_bl_bgrnd');
    $(".open").find(".module-hdl").addClass('toggle_cl_bl_bgrnd');
}

$('.module').each(function () {
    $(this).find('.element').responsiveEqualHeightGrid();
});

let images = document.querySelectorAll(".lazy, .lazynow, .lazygallery");
lazyload(images);

//TOGGLEBOXEN WEIN
$(document).ready(function () {
    $('.wine-holder .element').responsiveEqualHeightGrid();
});

//Activierung der Produkte/Artikel Rezeptseite
$(".ingredients li a").on("click", function () {
    $(this).closest(".content-holder").find(".ingredients li a").removeClass("active");
    $(this).addClass("active");
});

/** Swipe for Recipe slider and Navigation **/
/**, allowPageScroll:"vertical"**/

//CSS Resets
$(".img-frame").each(function () {
    if ($(".img-frame").next('div').is('.intro_teaser')) {
        if ($(this).next("div").hasClass("intro_teaser")) {
            $(this).css("margin-top", 0);
        }
    }
});

$(".text-module").each(function () {
    if ($(this).children('div').is('.intro_teaser')) {
        if ($(this).children('.intro_teaser').children("div").hasClass("lst-blue")) {
            $(this).css("margin-top", 40);
        }
    }
});

//OVERLAY
$(document).ready(function () {
    if ($('#openpro').length > 0) {
        //uebernommen aus JQuery-Doku um aktuellen Wert aus textarea MIT Zeilenumbruechen zu bekommen
        //http://api.jquery.com/val/#val
        $.valHooks.textarea = {
            get: function (elem) {
                return elem.value.replace(/\r?\n/g, "\r\n");
            }
        };
    }
    $('.sapat, .footerpop').on("click",function (e) {
        e.preventDefault();
        const isValid = !!$(this).attr('href')?.trim() && !$(this).attr('href')?.includes('#');
        if (isValid){
            //CODE AP
            var thishref = $(this).attr("href");
            if ($(this).attr("id") == 'openpro') {
                $('input:checked').each(function () {
                    thishref = thishref + "&" + $(this).attr("name") + "=on";
                });
                $('input[type="text"]').each(function () {
                    thishref = thishref + "&" + $(this).attr("name") + "=" + $(this).val();
                });
                $('textarea').each(function () {
                    //bekommt zeilenumbrueche richtig raus, kann diese aber nicht so einfach uebergeben
                    thishref = thishref + "&" + $(this).attr("name") + "=" + encodeURI($(this).val());
                });
                $('select > option:selected').each(function () {
                    thishref = thishref + "&" + $(this).parent().attr("name") + "=" + $(this).attr('value');
                });
            }
            //ENDE CODE AP
            $.magnificPopup.open({
                items: {
                    src: thishref,
                    type: 'ajax',
                    alignTop: true,
                    overflowY: 'scroll'
                },
                ajax: {
                    settings: null, // Ajax settings object that will extend default one - http://api.jquery.com/jQuery.ajax/#jQuery-ajax-settings
                    // For example:
                    // settings: {cache:false, async:false}
                    //cursor: 'mfp-ajax-cur', // CSS class that will be added to body during the loading (adds "progress" cursor)
                    tError: '<a href="%url%">Der Inhalt</a> konnte nicht geladen werden.' //  Error message, can contain %curr% and %total% tags if gallery is enabled
                },
                modal: true,
                closeOnBgClick:true

            });
            $('.mfp-content').click((e)=>{ if(e.target.classList.contains('mfp-content')) {$.magnificPopup.close();} });

        }
    });
});
//ENDE OVERLAY

function personalizeAttribute(thisobj, attr, val) {
    var old = thisobj.attr(attr);
    thisobj.attr(attr, old.replace("0", val));
}
function addInputs(counter) {
    const dates = $('#perstemplate').find('.sem-dates p').clone(true);
    const options = $('#perstemplate').find('.sem-options p select').html();
    $('.attendee-box').last().find('.sem-dates').append(dates);
    $('.attendee-box').last().find('.sem-options p select').append(options);
    $('.attendee-box').last().find('.sem-dates').find('input').attr('name', 'chosentime' + counter).attr("data-validate-checkbox-help", 'help-attendee-time-empty' + counter);
    for (var x = 0; x <= $('.attendee-box').last().find('.sem-dates').find('input').length; x++) {
        $($('.attendee-box').last().find('.sem-dates').find('input')[x]).attr('id', 'chosentime' + counter + '_' + x);
        $($('.attendee-box').last().find('.sem-dates').find('label')[x]).attr('for', 'chosentime' + counter + '_' + x);
    }
    $(".attendee-box").last().find('.sem-dates').find('input');
    $('.attendee-box').last().find('.sem-dates').find('span.input-invalid-help').addClass("help-attendee-time-empty" + counter);
}
function addNewPersons(persCount) {
    if ($('#perstemplate').length > 0) {
        var template = $('#perstemplate');
        var title = template.find('.lr-head strong').text();
        var nameLabel = template.find('.col-sm-12:first div p label').text();
        var dateLabel = template.find('.sem-dates').prev('div').find('label').text();
        var optionLabel = template.find('.sem-options').prev('div').find('label').text();
        var buttonText = template.find('.add-btn').text();
        var semOrNot = $('#perstemplate').attr('data-sem');
        semOrNot = (semOrNot == 'true');
        var attendeeCount = $('.attendee-box').not('#perstemplate').length;
        var maxPersCount = $("#wbemaxpers").data("maxperscnt") || 10;

        if (attendeeCount > 0) {
            persCount = persCount - attendeeCount;
        }
        if (persCount <= maxPersCount && (parseInt(persCount) + parseInt(attendeeCount)) <= maxPersCount && parseInt(persCount) > 0) {
            for (let i = 0; i < persCount; i++) {
                attendeeCount++;
                var dummyTemplate = '<div class="col-lg-12 lr-outlined lr-wrapper attendee-box"><div class="lr-head"><strong>' + title + attendeeCount + '<\/strong><\/div><div class=\"col-sm-12\"><div class=\"col-sm-3\"><p><label for=\"name' + attendeeCount + '\">' + nameLabel + '<\/label><\/p><\/div><div class=\"col-sm-4\"><p><input class=\"validate-nonempty\" data-validate-nonempty-help=\"help-attendee-name-empty-' + attendeeCount + '\" name=\"name' + attendeeCount + '\" type=\"text\" required=\"required\" value=\"\"><span class=\"input-invalid-help help-attendee-name-empty-' + attendeeCount + '\">Bitte geben Sie einen Namen ein.</span><\/p><\/div><div class=\"col-sm-5 padded-left\"><\/div><\/div><div class=\"col-sm-12\"><div class=\"col-sm-3\"><p><label for=\"chosentime' + attendeeCount + '\">' + dateLabel + '<\/label><\/p><\/div><div class=\"col-sm-4 sem-dates\"><\/div><div class=\"col-sm-5 padded-left\"><\/div><\/div><div class=\"col-sm-12\"><div class=\"col-sm-3\"><p><label for=\"teilnahme_sem_p' + attendeeCount + '\">' + optionLabel + '<\/label><\/p><\/div><div class=\"col-sm-4 sem-options\"><p><select class=\"selectBox\" name=\"teilnahme_sem_p' + attendeeCount + '\"><\/select><\/p><\/div><div class=\"col-sm-5 padded-left\"><button class=\"btn-blue add-btn\" type=\"button\">' + buttonText + '<\/button><\/div><\/div><div class=\"clearfix\"><\/div><\/div>';
                var dummyTemplatewoSem = '<div class=\"col-lg-12 lr-sep-top lr-wrapper attendee-box\"><div class=\"lr-head\"><strong>' + title + attendeeCount + '<\/strong><\/div><div class=\"col-sm-12\"><div class=\"col-sm-3\"><p><label for=\"name' + attendeeCount + '\">' + nameLabel + '<\/label><\/p><\/div><div class=\"col-sm-4\"><p><input name=\"name' + attendeeCount + '\" type=\"text\" required=\"required\" value=\"\"><\/p><\/div><div class=\"col-sm-5 padded-left\"><\/div><\/div><div class=\"col-sm-12\"><div class=\"col-sm-3\"><p><label for=\"chosentime' + attendeeCount + '\">' + dateLabel + '<\/label><\/p><\/div><div class=\"col-sm-4 sem-dates\"><\/div><div class=\"col-sm-5 padded-left\"><\/div><\/div><div class=\"clearfix\"><\/div><\/div>';
                semOrNot ? $('.attendee-box').last().after(dummyTemplate) : $('.attendee-box').last().after(dummyTemplatewoSem);
                addInputs(attendeeCount);
            }
        }
        else if (parseInt(persCount) < 0) {
            persCount = persCount * -1;
            for (let i = 0; i < persCount; i++) {
                $('.attendee-box').last().empty().remove();
            }
        }
    } else if ($('#wbeperstemplate').length > 0) {
        let attendeeCount = $('.attendee-box').not('#wbeperstemplate').length;
        let maxPersCount = $("#wbemaxpers").data("maxperscnt") || 10;
        persCount = parseInt(persCount);
        if (persCount <= maxPersCount && persCount > 0) {
            if (attendeeCount > 0) {
                persCount = persCount - attendeeCount;
            }
            if (persCount < 0) {
                persCount = persCount * -1;
                for (let i = 0; i < persCount; i++) {
                    $('.attendee-box').last().empty().remove();
                }
            } else {
                for (let i = 0; i < persCount; i++) {
                    var $newAttendee = $('#wbeperstemplate').clone();
                    var persnr = attendeeCount + i + 1;
                    $newAttendee.removeAttr("style").removeAttr("id");
                    $newAttendee.find(".attendee-head").append(persnr);
                    $newAttendee.find("label").each(function () {
                        personalizeAttribute($(this), "for", persnr);
                    });
                    $newAttendee.find("input, select").each(function () {
                        personalizeAttribute($(this), "id", persnr);
                        personalizeAttribute($(this), "name", persnr);
                        var addattr = $(this).attr("add-attr");
                        if ((typeof addattr != "undefined") && (addattr != "")) {
                            $(this).attr(addattr, addattr);
                        }
                    });
                    $('.attendee-box').last().after($newAttendee);
                }
            }
        }
    }
}
//Messeanmeldung
$(document).ready(function () {
    $("[name='nrteilnehmer']").on('input', function(){
        var x = $('input[name="nrteilnehmer"]').val();
        var persons = (!isNaN(x) ? x : 0);
        addNewPersons(persons);
    });
    $('#update').on('click', function (e) {
        if ($("#update").is(":visible")) {
            e.preventDefault();
            var x = $('input[name="nrteilnehmer"]').val();
            var persons = (!isNaN(x) ? x : 0);
            addNewPersons(persons);
        }
        else {
            e.preventDefault();
        }
    });
})

//Basisdaten toggle (Mein Profil auf chefsculinar.de)
$(document).ready(function () {
    $('.togglebasicdata').on('click', function () {
        var toopen = $(this).attr('opentgl');
        var toclose = $(this).attr('closetgl');
        if (($(toclose).length > 0) && ($(toopen).length > 0)) {
            $('.togglebasicdatahide').hide();
            $('.togglebasicdatashow').show();
            $(toclose).hide();
            $(toopen).show();
            $(toopen).find('.element').responsiveEqualHeightGrid();
        }
    });
});


//Print Page/Window
$(".print button").on("click", function () {
    window.print()
});

// Back to top button
const back_to_top_button = $(".relaunch-inline-tabs").length > 0 ? '<a href="#top" class="backtotop" style="right:60px;"></a>' : '<a href="#top" class="backtotop"></a>';
$("body").append(back_to_top_button);



// Show if scroll
$(function () {
    $(window).on("scroll",function () {
        if ($(this).scrollTop() > 400) {
            $('.backtotop').fadeIn();
        } else {
            $('.backtotop').fadeOut();
        }
    });

    $('.backtotop').on("click",function () {
        $('body,html').animate({
            scrollTop: 0
        }, 1000);
        return false;
    });
});

//Fix for Browser-specific form validation jumps -> the fixed header hides the input field without it

var delay = 0;
var offset = 150;

document.addEventListener('invalid', function (e) {
    $(e.target).addClass("invalid");
    $('html, body').animate({ scrollTop: $($(".invalid")[0]).offset().top - offset }, delay);
}, true);
document.addEventListener('change', function (e) {
    $(e.target).removeClass("invalid");
}, true);




//new registry

$(document).ready(function () {

    function validate(eventToPrevent) {
        var errorFound = false;

        //Achtung: Die Reihenfolge der Validierung ist wichtig. Nicht ohne Grund verändern!!

        $("[data-checked-dependant]:visible").each(function () {
            if ($($(this).data("checked-dependant")).is(":checked")) {
                $(this).addClass("validate-nonempty");
                if ($(this).attr("type") !== "password") {
                    $(this).addClass("validate-numeric-9");
                }
            }
            else {
                $(this).removeClass("validate-nonempty");
                $(this).removeClass("validate-numeric-9");
                $(this).removeClass("input-invalid");
                $("." + $(this).data("validate-nonempty-help")).css("display", "none");
                $("." + $(this).data("validate-numeric-help")).css("display", "none");
            }
        });

        $(".validate-nonempty:visible").each(function () {
            if ($(this).val().length === 0) {
                errorFound = true;
                $("." + $(this).data("validate-nonempty-help")).css("display", "block");
                $(this).addClass("input-invalid");
                $(this).addClass("hasError");
            }
            else {
                $("." + $(this).data("validate-nonempty-help")).css("display", "none");
                $(this).removeClass("input-invalid");
                $(this).removeClass("hasError");
            }
        });

        $(".validate-checkbox:visible").each(function () {
            if ($("[name=" + $(this).attr("name") + "]:checked").length === 0) {
                errorFound = true;
                $("." + $(this).data("validate-checkbox-help")).css("display", "block");
                $(this).addClass("input-invalid");
                $(this).addClass("hasError");
            }
            else {
                $("." + $(this).data("validate-checkbox-help")).css("display", "none");
                $(this).removeClass("input-invalid");
                $(this).removeClass("hasError");
            }
        });

        $(".validate-email:visible").each(function () {
            if ($(this).val().length <= 5 || validateEmail($(this).val()) === false) {
                errorFound = true;
                $("." + $(this).data("validate-email-help")).css("display", "block");
                $(this).addClass("input-invalid");
                $(this).addClass("hasError");
            }
            else {
                $("." + $(this).data("validate-email-help")).css("display", "none");
                $(this).removeClass("input-invalid");
                $(this).removeClass("hasError");
            }
        });

        $(".validate-numeric:visible").each(function () {
            var re = /^\d+$/;
            if (re.test($(this).val().trim()) === false && !$(this).hasClass("hasError")) {
                errorFound = true;
                $("." + $(this).data("validate-numeric-help")).css("display", "block");
                $(this).addClass("input-invalid");
                $(this).addClass("hasError");
            }

            else if (!$(this).hasClass("hasError")) {
                $("." + $(this).data("validate-numeric-help")).css("display", "none");
                $(this).removeClass("input-invalid");
                $(this).removeClass("hasError");
            }
        });

        $(".validate-nonzero:visible").each(function () {
            if ($(this).val() === "0" && !$(this).hasClass("hasError")) {
                errorFound = true;
                $("." + $(this).data("validate-nonzero-help")).css("display", "block");
                $(this).addClass("input-invalid");
                $(this).addClass("hasError");
            }

            else if (!$(this).hasClass("hasError")) {
                $("." + $(this).data("validate-nonzero-help")).css("display", "none");
                $(this).removeClass("input-invalid");
                $(this).removeClass("hasError");
            }
        });
        $(".validate-numeric-9-optional:visible").each(function () {
            var re = /^(\d{9})?$/;
            if (re.test($(this).val()) === false && !$(this).hasClass("hasError")) {
                errorFound = true;
                $("." + $(this).data("validate-numeric-9-help")).css("display", "block");
                $(this).addClass("input-invalid");
                $(this).addClass("hasError");
            }
            else if (!$(this).hasClass("hasError")) {
                $("." + $(this).data("validate-numeric-9-help")).css("display", "none");
                $(this).removeClass("input-invalid");
                $(this).removeClass("hasError");
            }
        });

        $(".validate-numeric-9:visible").each(function () {
            var re = /^\d{9}$/;
            if (re.test($(this).val()) === false && !$(this).hasClass("hasError")) {
                errorFound = true;
                $("." + $(this).data("validate-numeric-9-help")).css("display", "block");
                $(this).addClass("input-invalid");
                $(this).addClass("hasError");
            }
            else if (!$(this).hasClass("hasError")) {
                $("." + $(this).data("validate-numeric-9-help")).css("display", "none");
                $(this).removeClass("input-invalid");
                $(this).removeClass("hasError");
            }
        });

        $(".validate-numeric-5:visible").each(function () {
            var re = /^\d{5}$/;
            if (re.test($(this).val()) === false && !$(this).hasClass("hasError")) {
                errorFound = true;
                $("." + $(this).data("validate-numeric-5-help")).css("display", "block");
                $(this).addClass("input-invalid");
                $(this).addClass("hasError");
            }
            else if (!$(this).hasClass("hasError")) {
                $("." + $(this).data("validate-numeric-5-help")).css("display", "none");
                $(this).removeClass("input-invalid");
                $(this).removeClass("hasError");
            }
        });

        $(".validate-numeric-4-5:visible").each(function () {
            var re = /^\d{4,5}$/;
            if (re.test($(this).val()) === false && !$(this).hasClass("hasError")) {
                errorFound = true;
                $("." + $(this).data("validate-numeric-4-5-help")).css("display", "block");
                $(this).addClass("input-invalid");
                $(this).addClass("hasError");
            }
            else if (!$(this).hasClass("hasError")) {
                $("." + $(this).data("validate-numeric-4-5-help")).css("display", "none");
                $(this).removeClass("input-invalid");
                $(this).removeClass("hasError");
            }
        });

        $(".validate-characters-with-hyphen:visible").each(function () {
            var re = /^[A-Za-zäöüß_\-– .]+$/;
            if (re.test($(this).val()) === false && !$(this).hasClass("hasError")) {
                errorFound = true;
                $("." + $(this).data("validate-char-hyphen-help")).css("display", "block");
                $(this).addClass("input-invalid");
                $(this).addClass("hasError");
            }
            else if (!$(this).hasClass("hasError")) {
                $("." + $(this).data("validate-char-hyphen-help")).css("display", "none");
                $(this).removeClass("input-invalid");
                $(this).removeClass("hasError");
            }
        });

        $(".validate-characters-with-hyphen-space-numeric:visible").each(function () {
            var re = /^[0-9A-Za-zäöü_\-– .ß]+$/;
            if (re.test($(this).val()) === false && !$(this).hasClass("hasError")) {
                errorFound = true;
                $("." + $(this).data("validate-char-hyphen-space-numeric-help")).css("display", "block");
                $(this).addClass("input-invalid");
                $(this).addClass("hasError");
            }
            else if (!$(this).hasClass("hasError")) {
                $("." + $(this).data("validate-char-hyphen-space-numeric-help")).css("display", "none");
                $(this).removeClass("input-invalid");
                $(this).removeClass("hasError");
            }
        });

        $(".ql-container.validate-quill").each(function () {
            if ($(this).text() === "" && !$(this).hasClass("hasError")) {
                errorFound = true;
                $("." + $(this).data("validate-quill-help")).css("display", "block");
                $(this).addClass("input-invalid");
                $(this).addClass("hasError");
            }
            else if (!$(this).hasClass("hasError")) {
                $("." + $(this).data("validate-quill-help")).css("display", "none");
                $(this).removeClass("input-invalid");
                $(this).removeClass("hasError");
            }
        });

        var validatekn = function (selector) {
            if (!selector.hasClass("hasError")) {
                $.ajax({
                    async: false,
                    url: "async_kn",
                    method: "post",
                    data: {
                        kundennummer: $("[name=kundennummer]").val(),
                        plz: $("[name=plz]").val()
                    },
                    success: function (result) {

                        if (result.trim() === "NOT OK" || result.trim() === "invalid input") {
                            errorFound = true;
                            $("." + $(".validate-kundennummer,.validate-kundennummer-generic").data("validate-kundennummer-help")).css("display", "block");
                            $(".validate-kundennummer,.validate-kundennummer-generic").addClass("input-invalid");
                            $(".validate-kundennummer,.validate-kundennummer-generic").addClass("hasError");
                        }
                        else {
                            $("." + $(".validate-kundennummer,.validate-kundennummer-generic").data("validate-kundennummer-help")).css("display", "none");
                            $(".validate-kundennummer,.validate-kundennummer-generic").removeClass("input-invalid");
                            $(".validate-kundennummer,.validate-kundennummer-generic").removeClass("hasError");
                        }
                    }
                });
            }
        };

        $(".validate-kundennummer:visible").each(function () {
            if ($("#reg-kundeyes").is(":checked")) {
                validatekn($(this));
            }
        });

        $(".validate-kundennummer-generic:visible").each(function () {
            validatekn($(this));
        });

        $(".validate-legal:visible").each(function () {
            if (!$(this).is(":checked")) {
                errorFound = true;
                $("." + $(this).data("validate-legal-help")).css("display", "block");
                //$(this).addClass("input-invalid");
                $(this).addClass("hasError");
            }
            else {
                $("." + $(this).data("validate-legal-help")).css("display", "none");
                //$(this).removeClass("input-invalid");
                $(this).removeClass("hasError");
            }
        });

        if ($(".validate-onechecked:visible").length > 0) {
            var checkboxes = $(".validate-onechecked:visible");
            if (checkboxes.filter(":checked").length === 0) {
                errorFound = true;
                $("." + checkboxes.eq(0).data("validate-onechecked-help")).css("display", "block");
                checkboxes.eq(0).addClass("hasError");
            }
            else {
                $("." + checkboxes.eq(0).data("validate-legal-help")).css("display", "none");
                checkboxes.eq(0).removeClass("hasError");
            }
        }

        if (errorFound === true) {
            eventToPrevent.preventDefault();
            eventToPrevent.stopPropagation();
            eventToPrevent.stopImmediatePropagation();


            if(!$(".cc-login-container").is(":visible")){
                var navHeight = $(".stickheader").length ? ($(".mainnav-desk.stickheader").is(":visible") ? $(".mainnav-desk.stickheader").height() : $(".stickheader:not(.mainnav-desk)").height()) : 0;

                var highestOffset = -1;

                $(".input-invalid, .input-invalid-help:visible, .hasError , label[for=" + $($(".input-invalid")[0]).attr("id") + "], label[for=" + $($(".input-invalid")[0]).attr("name") + "]").each(function () {
                    if ($(this).offset().top - navHeight <= highestOffset || highestOffset === -1) {
                        highestOffset = $(this).offset().top - navHeight;
                    }
                });

                $("html,body").animate({
                    scrollTop: highestOffset
                }, 500);
            }

        }
        else {

        }
    };

    $("body").on("change input keyup", ".input-invalid.hasError, .hasError .input-invalid", function () {
        $(this).removeClass("input-invalid");
    });

    $("input#reg-kundeno").on("change",function () {
        $("." + $(".validate-kundennummer").data("validate-kundennummer-help")).css("display", "none");
        $(".validate-kundennummer").removeClass("input-invalid");
        $(".validate-kundennummer").removeClass("hasError");

        $(".validate-kundennummer").siblings(".input-invalid-help").css("display", "none");
    });

    //Validation on submit

    $("button[name=btnsubmit]").on("click", function (e) {
        if ($(this).val() === "regsubmit" || $(this).val() === "cupsubmit") {
            validate(e);
        }
    });

    $(".validatethis").on("click", function (e) {
        validate(e);
    });

    //E-Mail validation 

    var validateEmail = function (email) {
        var re = /^([^,\r\n]+)@([^,\r\n]+)\.([^,\r\n]{2,})$/;
        return re.test(email);
    };
    $(".type-validation-email").on("propertychange change keyup input paste", function () {
        if ($(this).val().length > 5 && validateEmail($(this).val()) === true) {
            $(this).siblings(".input-valid-false").remove();
            $(this).after("<span class='input-valid-true'></span>");
        }
        else if ($(this).val().length <= 5) {
            $(this).siblings(".input-valid-false").remove();
            $(this).siblings(".input-valid-true").remove();
        }
        else {
            $(this).siblings(".input-valid-true").remove();
            $(this).after("<span class='input-valid-false'></span>");
        }
    });

    $(".type-validation-pw,.type-validation-pw-confirm").on("propertychange change keyup input paste", function () {
        if ($(this).val().length >= 8) {
            $(this).siblings(".input-valid-false").remove();
            $(this).after("<span class='input-valid-true'></span>");
        }
        else if ($(this).val().length > 0) {
            $(this).siblings(".input-valid-true").remove();
            $(this).after("<span class='input-valid-false'></span>");
        }
        else {
            $(this).siblings(".input-valid-false").remove();
            $(this).siblings(".input-valid-true").remove();
        }
        if ($(".type-validation-pw-confirm").val().length > 0 && $(".type-validation-pw").val() !== $(".type-validation-pw-confirm").val()) {
            $(".type-validation-pw-confirm").siblings(".input-valid-true").remove();
            $(".type-validation-pw-confirm").after("<span class='input-valid-false'></span>");
        }
        else if ($(".type-validation-pw-confirm").val().length >= 6 && $(".type-validation-pw").val() === $(".type-validation-pw-confirm").val()) {
            $(".type-validation-pw-confirm").siblings(".input-valid-false").remove();
            $(".type-validation-pw-confirm").after("<span class='input-valid-true'></span>");
        }
    });

    initregistration();

    $(window).on("resize",function () {
        $(".profilebox").responsiveEqualHeightGrid();
    });
    $(".profilebox").responsiveEqualHeightGrid();

    $("body").on("click", ".cclogin .closepopup", function (e) {
        e.preventDefault();
        $("body").removeClass("cc-login-active");
    });

    $("body").on("mousedown", ".cc-login-container", function () {
        $("body").removeClass("cc-login-active");
    });
    $("body").on("click mousedown", ".cc-login-container .cclogin", function (e) {
        e.stopPropagation();
    });

    $(".cc-login-container").detach().prependTo("body");

    $("body").on("click", ".toggle-login-box", function (e) {
        e.preventDefault();
        $("body").addClass("cc-login-active");
    });


    function login(e) {
        validate(e);
        var uname = $(".cc-login-container input[name=username]").val();
        var password = $(".cc-login-container input[name=password]").val();
        var url = "";
        if (location.href.indexOf("preview") != -1) {
            url = "/preview/loginAsync.htm";
        }
        else {
            url = "/loginAsync.htm";
        }
        $.ajax({
            url: url,
            method: "post",
            cache: false,
            headers: {
                "cache-control": "no-cache"
            },
            timeout: 15000,
            data: {
                action: "login",
                uname: uname,
                password: password,
                logintarget: $('input[name=\'logintarget\']').val()
            },
            success: function (res) {
                if (typeof (res) === "string") {
                    var resJson = JSON.parse(res);
                }
                else {
                    resJson = res;
                }

                if (resJson["status"] === "success") {
                    if (resJson["redirect"] != undefined) {
                        //document.location.href = resJson["redirect"];

                        window.location.href = window.location.origin + "/" + resJson["redirect"];
                        return false;
                    }
                    else {
                        //document.location.href = newLoc;
                        //window.location = newLoc;
                        window.location.reload(true);
                        return false;
                    }
                }
                else if (typeof (resJson["status"]) === "undefined") {
                    //temp fix for 
                    window.location.reload(true);
                }
                else if (resJson["status"] === "fail" && resJson["error"] === "wronguserorpw") {
                    $(".cc-login-container .help-user-pw-unknown").show();
                }
            }
        });
    };

    $("body").on("keyup", ".cc-login-container input[name=username],.cc-login-container input[name=password]", function (e) {
        var keycode = e.keyCode || e.which;
        if (keycode != 13) {
            return;
        }
        login(e);
    });

    $("body").on("click keyup touchend", ".cc-login-container .lightbox-login-button", function (e) {

        login(e);
    });


    //inithome();
    initsliders();
    initpartner();
    initwerbung();
    initansprechpartner();
    initautocomplete();
    initsocialfeed();
    initrecipe();

    //$(".katalog").not(".bestellen").responsiveEqualHeightGrid();
    $("input[type=checkbox][name=katalog]").on("click", function () {
        $("input#katalogliste").val("");
        var newKatalogliste = [];
        $("input[type=checkbox]:checked").each(function () {
            newKatalogliste.push($(this).val());
        });
        $("input#katalogliste").val(newKatalogliste.join("<br>"));
    });

    $(".btn-katalogformular").on("click", function (e) {
        if ($("input#katalogliste").val() === "") {
            e.preventDefault();
            $(".warning-no-katalog").css("visibility", "visible");
        }
        else {
            $(".warning-no-katalog").css("visibility", "hidden");
        }
    });

    //relaunch


    $(".relaunch-image-teaser.hover-overlay").on("mouseenter touchend", function () {
        $(this).parents(".relaunch-gallery-bigimage").find(".main-overlay").removeClass("active");
        $(this).siblings(".hover-overlay").find(".main-overlay").removeClass("active");
        $(this).find(".main-overlay").addClass("active");
    });

    $(".relaunch-image-teaser.hover-overlay").on("touchstart click", function (e) {
        if (!$(this).find(".main-overlay").hasClass("active")) {
            e.preventDefault();
        }
    });

    function fixGallery() {
        $(".relaunch-gallery-bigimage:not(.fullwidth-main)").each(function () {
            var one = $(this).find(".listimg .listimg-item:nth-child(1) > img");
            var two = one.parent().next().find("> img");
            if (one.length && two.length) {
                var main = $(this).find(".mainimg img");
                one.css("height", "");
                two.css("height", "");
                main.css("height", "");
                if (window.innerWidth > 767) {
                    one.outerHeight(one.outerHeight());
                    two.outerHeight(two.outerHeight());
                    main.outerHeight(one.outerHeight() + two.outerHeight() + 6);
                }
            }

        });
    };
    $(window).on("resize", function () {
        fixGallery();
    });
    setTimeout(fixGallery,1000);
    fixGallery();

    $(".relaunch-tabs > .tabnavi .tab").on("click", function () {
        $(this).parent().siblings(".tabwrap").find(".tab").removeClass("active");
        $(this).addClass("active");

        var tab_id = $(this).attr("data-tab");
        var tab = $(this).parent().parent().siblings(".tabcontents").find("> .tabcontent[data-tab='" + tab_id + "']");
        tab.siblings(".tabcontent").removeClass("active");
        tab.addClass("active");
        $(window).trigger("scroll");
    });

    function activateTab(clickedTab, autoScroll) {
        if (autoScroll === undefined) {
            autoScroll = true;
        }
        var numtabstoshow = $(this).parents(".tabnavi").attr("data-showspan");
        if (numtabstoshow === undefined) {
            numtabstoshow = 1;
        }

        clickedTab.siblings(".tab").removeClass("active");
        clickedTab.addClass("active");
        var tab_id = clickedTab.attr("data-tab");
        var tab = clickedTab.parent().parent().siblings(".tabcontents").find(".tabcontent[data-tab=" + tab_id + "]");
        tab.siblings(".tabcontent").removeClass("active");
        tab.nextAll().addBack().slice(0, numtabstoshow).addClass("active");

        if (autoScroll && window.innerWidth <= 1279) {
            $("html,body").scrollTop(tab.offset().top - 80);
        }
    }


    $(".relaunch-inline-tabs > .tabnavi .tab").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        activateTab($(this));
        $(window).trigger("scroll");
    });

    $(".relaunch-inline-tabs .toggler").on("click", function () {
        $(this).toggleClass("active");
    });
    $(".relaunch-inline-tabs .toggler-headline").on("click", function () {
        $(this).parents(".tabnavi").siblings(".toggler").toggleClass("active");
    });

    $(".relaunch-inline-tabs .tabnavi .tab").each(function () {
        var tab_id = $(this).attr("data-tab");
        var content = $(this).parent().parent().siblings(".tabcontents").find(".tabcontent[data-tab='" + tab_id + "']");
        if (content.length === 0) {
            $(this).addClass("disabled");
        }
    });

    $(".relaunch-tabs").each(function () {
        $(this).find(".tabwrap:first-child .tab").trigger("click");
    });
    $(".relaunch-inline-tabs").each(function () {
        $($(this).find(".tab:not(.disabled)")[0]).trigger("click");
    });

    $(".relaunch-dropdown-list").on("click", ".name", function () {
        $(this).siblings(".dropdown-content").slideToggle();
        $(this).toggleClass("open");
    });
    function positionTabnavi(navi) {
        if (navi.length === 0) {
            return;

        }
        var scrollwrapper = navi.find(".scrollwrapper");
        var viewport_height = window.innerHeight;
        var tabnavi_height = navi.outerHeight();

        var tabnavi_top_position = navi.position().top;
        var tabnavi_bottom_position = viewport_height - (tabnavi_height + tabnavi_top_position);

        var scrollwrapper_rel_top_position = scrollwrapper.position().top;
        var scrollwrapper_abs_top_position = scrollwrapper_rel_top_position + tabnavi_top_position;
        var scrollwrapper_height = scrollwrapper.outerHeight();
        var scrollwrapper_abs_bottom_position = viewport_height - (scrollwrapper_abs_top_position + scrollwrapper_height);

        let options = {};
        if (scrollwrapper_abs_bottom_position < 0) {
            navi.addClass("scrolldown-active");
            options.bottom = tabnavi_bottom_position * -1;
        }
        else {
            navi.removeClass("scrolldown-active");
            options.bottom = 0;
        }
        if (scrollwrapper_rel_top_position < 0) {
            navi.addClass("scrollup-active");
            options.top = 0;
        }
        else {
            navi.removeClass("scrollup-active");
        }
        positionTabnaviArrows(navi, options);
    }
    function positionTabnaviArrows(navi, options) {
        var arrow_down = navi.find(".downarrow");
        var arrow_up = navi.find(".uparrow");
        arrow_down.css("bottom", options.bottom + "px");
        arrow_up.css("top", options.top + "px");
    }

    function scrollTabNaviDown(navi) {
        var scrollwrapper = navi.find(".scrollwrapper");
        var viewportheight = window.innerHeight;
        var scrollwrapper_offset_top = scrollwrapper.position().top;
        var scrollwrapper_offset_bottom = viewportheight - (navi.position().top + scrollwrapper_offset_top + scrollwrapper.outerHeight());
        if (scrollwrapper_offset_bottom < 0) { // scrollwrapper is offscreen below viewport
            var scrollwrapper_visible_height = (scrollwrapper.outerHeight() + scrollwrapper_offset_top + scrollwrapper_offset_bottom) - 40;
            scrollwrapper.css("top", (scrollwrapper_offset_top + Math.max(scrollwrapper_offset_bottom, -scrollwrapper_visible_height) - 40) + "px");
        }
    }

    function scrollTabNaviUp(navi) {
        var scrollwrapper = navi.find(".scrollwrapper");
        var viewportheight = window.innerHeight;
        var scrollwrapper_offset_top = scrollwrapper.position().top;
        var scrollwrapper_offset_bottom = viewportheight - (navi.position().top + scrollwrapper_offset_top + scrollwrapper.outerHeight());
        if (scrollwrapper_offset_top < 0) { // scrollwrapper is offscreen above viewport
            var scrollwrapper_visible_height = (scrollwrapper.outerHeight() + scrollwrapper_offset_top + scrollwrapper_offset_bottom) - 40;
            scrollwrapper.css("top", (scrollwrapper_offset_top - Math.max(scrollwrapper_offset_top, -scrollwrapper_visible_height)) + "px");
        }
    }

    $(".relaunch-inline-tabs .downarrow").on("click", function () {
        scrollTabNaviDown($(this).parent());
        positionTabnavi($(this).parent());
    });
    $(".relaunch-inline-tabs .uparrow").on("click", function () {
        scrollTabNaviUp($(this).parent());
        positionTabnavi($(this).parent());
    });

    $(document).on("scroll", function () {
        setTimeout(function () {
            if (window.innerWidth <= 1279) {
                var tabcontents = $(".relaunch-inline-tabs .tabcontent:visible");
                for (var x = 0; x < tabcontents.length; x++) {
                    var height = window.innerHeight;
                    var top = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
                    var bottom = top + height;

                    if ($(tabcontents[x]).offset().top > top && $(tabcontents[x]).offset().top < bottom) {
                        var tab = $(tabcontents[x]).parent().siblings(".tabnavi").find(".tab[data-tab=" + $(tabcontents[x]).attr("data-tab") + "]");
                        activateTab(tab, false);
                        break;
                    }
                }
            }
        }, 100);

    });

    $(".relaunch-inline-tabs .tabnavi").each(function () {
        var that = $(this);
        positionTabnavi(that);
        $(window).on("resize",function () {
            positionTabnavi(that);
        });
        $(window).on("scroll", function () {
            positionTabnavi(that);
        });
    });

    $(".autosplit").each(function () {
        var clone = $(this).clone(true);
        clone.find(".splitthis").remove();
        clone.insertAfter($(this));
        var length = $(this).find(".splitthis").length;
        var slicelength = Math.ceil(length / 2);

        var tobesliced = $(this).find(".splitthis").slice(slicelength, length);
        tobesliced.appendTo(clone.find(".relaunch-dropdown-list"));
    });


    $(".relaunch-openall").on("click", function () {
        var entries = $(this).siblings(".relaunch-dropdown-list").find(".name");
        entries.siblings(".dropdown-content").slideDown();
        entries.addClass("open");
        $(this).hide();
        $(this).siblings(".relaunch-closeall").show();
    });
    $(".relaunch-closeall").on("click", function () {
        var entries = $(this).siblings(".relaunch-dropdown-list").find(".name.open");
        entries.siblings(".dropdown-content").slideUp();
        entries.removeClass("open");
        $(this).hide();
        $(this).siblings(".relaunch-openall").show();
    });

    $(".relaunch-module-content").each(function () {
        $(this).find(".relaunch-image-text-teaser .content").responsiveEqualHeightGrid();
    });



    initkarrierefilter();

    //Lightbox 

    var lb_string = "<div class='relaunch-lightbox-container'><div class='relaunch-lightbox'><a href='' class='relaunch-lightbox-close'>schließen</a><header class='relaunch-lightbox-header relaunch-dot-border-bottom'></header><div class='relaunch-lightbox-content'><div class='scroller'></div></div></div>";
    $("body").prepend($(lb_string));


    $(".relaunch-lightbox a.relaunch-lightbox-close").on("click", function (e) {
        e.preventDefault();
        $("body").removeClass("relaunch-lightbox-active");
    });

    $("body").on("click", function () {
        $("body").removeClass("relaunch-lightbox-active");
    });
    $(".relaunch-lightbox").on("click", function (e) {
        e.stopPropagation();
    });

    $(".lightbox-link").on("click", function (e) {
        e.preventDefault();
        var url = $(this).data("lightbox-href");
        $.ajax({
            url: url,
        }).done(function (res) {
            var header = res["header"].replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
            var content = res["content"].replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
            setLightbox(header, content);
        });
    });
    setLightboxOverflowable();
    $(window).on("resize", _.throttle(setLightboxOverflowable, 200));

    //Rueckmeldeformular Messe: Multiperson-Select
    if ($(".multiperson").length > 0) {
        initmesserueckmeldung();
    }

    $(".card--dropdown ").on("click", ".card__head", function () {
        $(this).parents(".card--dropdown").toggleClass("card--dropdown--active");
    });

    initnewsletter();
    inittimeline();

    //Content animations

    function handleIntersect(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add("canimation--run");
                observer.unobserve(entry.target);
            }
        });
    }

    const observer = new IntersectionObserver(handleIntersect, {
        rootMargin: "-20% 0% -20% 0%",
        threshold: 0
    });

    document.querySelectorAll(".canimation").forEach(el => {
        observer.observe(el);
    });


    $(".d2form__label--checkbox").on("change", function(){
        if($(this).find("input[type='checkbox']").is(":checked")){
            $(this).addClass("d2form__label--checkbox--checked");
        }else{
            $(this).removeClass("d2form__label--checkbox--checked");
        }
    });

    initsmc();
    function d2BoxSetHeight(elem, box){
        if(window.innerWidth > 767){
            const height = box.outerHeight();
            box.css("marginTop", "-" + height/2 + "px");
        }
        else{
            box.css("marginTop", '');
        }

    }
    $(".d2banner").each(function(){
        const throttled = _.throttle(()=> d2BoxSetHeight($(this), $(this).find(".d2banner__box")), 300);
        throttled();
        $(window).on("resize", throttled);
    });

    $(".d2contact").on("click", function(e){
        if($(e.target).is("a")){
            return;
        }
        if($(e.target).hasClass("d2contact__close")){
            $(this).find(".d2contact__hover").removeClass("d2contact__hover--active");
        }
        else{
            $(this).find(".d2contact__hover").addClass("d2contact__hover--active");
        }
    });

    initlegacyutils();
});
